module.exports = __webpack_public_path__ + "static/media/usage_habitation.2193b278.png";